module.exports = __webpack_public_path__ + "static/media/galerija_2019 (6).245fcb2e.jpg";